import axios from 'axios';
import { backendUrl } from '../constants/urls';
import { BusinessCategoryValues } from '../components/business-category/types';
import clientApi from '../constants/urls';

const createBusinessCategory = (values: BusinessCategoryValues) => {
	return clientApi.post(`${backendUrl}/businessCategory`, values);
};

const retrieveBusinesses = () => {
	return clientApi.get(`${backendUrl}/businessCategory`);
};

const UpdateBusinessCategory = (id, category) => {
	return clientApi.put(`${backendUrl}/businessCategory/${id}`, category);
};

const deleteBusinessCategory = (id: string) => {
	return clientApi.delete(`${backendUrl}/businessCategory/${id}`);
};

const businessCategoryService = {
	createBusinessCategory,
	retrieveBusinesses,
	UpdateBusinessCategory,
	deleteBusinessCategory,
};

export default businessCategoryService;
